'use client';

import { track } from '@smartproxy/sp-tracker-js';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { usePrevious } from '@/hooks/usePrevious';
import {
  sendPageViewEvent,
  sendVirtualPageViewEvent,
} from '@/integrations/trackingScripts';

export function GlobalRouteChangeListener() {
  const pathname = usePathname();
  const isClient = typeof window !== 'undefined';
  const previousPathname = usePrevious(isClient ? pathname : null);

  useEffect(() => {
    !previousPathname &&
      sendPageViewEvent(window.location.href, document.referrer);
    previousPathname &&
      sendVirtualPageViewEvent(
        window.location.href,
        window.location.origin + previousPathname
      );

    track('$pageview');
  }, [pathname, previousPathname]);

  return null;
}
